import {Swiper} from 'swiper';
import 'swiper/css';
import {Navigation} from "swiper/modules";

export function locationGallerySwiper() {
    // Initialize swiper
    return new Swiper('.swiper', {
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 600,
        slideToClickedSlide: true,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 767px
            767: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            // when window width is >= 991px
            991: {
                slidesPerView: 'auto',
                spaceBetween: 24}
        }
    })
}

export function setColoursToSwiperButtons() {

    // Define buttons
    const arrowLeft = document.getElementById('slider_button_left');
    const arrowRight = document.getElementById('slider_button_right');

    arrowLeft.addEventListener('click', () => {
        arrowLeft.style.backgroundColor = '#18191d';
        arrowRight.style.backgroundColor = '#989da8';
    });
    arrowRight.addEventListener('click', () => {
        arrowRight.style.backgroundColor = '#18191d';
        arrowLeft.style.backgroundColor = '#989da8';
    });
}